import dayjs from 'dayjs'

export const PLENTY_ONLINE_PROMO_CODE = 'PLENTY80AND50'

export const PROMO_CODE_ACTIVE_PERIODS = [
  {
    start: dayjs('2025-06-12').startOf('day'),
    end: dayjs('2025-06-01').endOf('month')
  }
]
